import createIcon from '../../createIcon';

/**
 * @component @name HotelClass
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC4yNDAxNiAxMEgwLjY2MDE1Nkw2LjgzMDE2IDE0LjQxTDQuNDkwMTYgMjJMMTAuNjYwMiAxNy4zMUwxNi44NDAyIDIyTDE0LjQ5MDIgMTQuNDFMMjAuNjYwMiAxMEgxMy4wODAyTDEwLjY2MDIgMkw4LjI0MDE2IDEwWk0yMS4wMjAyIDIyTDE5LjE2MDIgMTUuOTlMMjMuMzQwMiAxM0gxOS45MDAyTDE2LjgyMDIgMTUuMkwxOC4yODAyIDE5LjkyTDIxLjAyMDIgMjJaTTE2LjY2MDIgOEwxNC44NDAyIDJMMTMuODAwMiA1LjQ1TDE0LjU3MDIgOEgxNi42NjAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HotelClass = createIcon('HotelClass', [
  [
    'path',
    {
      d: 'M8.24016 10H0.660156L6.83016 14.41L4.49016 22L10.6602 17.31L16.8402 22L14.4902 14.41L20.6602 10H13.0802L10.6602 2L8.24016 10ZM21.0202 22L19.1602 15.99L23.3402 13H19.9002L16.8202 15.2L18.2802 19.92L21.0202 22ZM16.6602 8L14.8402 2L13.8002 5.45L14.5702 8H16.6602Z',
      key: '1p8ybb',
    },
  ],
]);

export default HotelClass;
